import { Button } from '@shared/components/Button';
import { View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import { useDraggableContext } from './DraggableContext';

interface Props {
  showMore(): void;
  hasMore: boolean;
  isMoreLoading: boolean;
}

export function CardListFooter({ showMore, hasMore, isMoreLoading }: Props) {
  const { isDragging } = useDraggableContext();
  return (
    <View row paddingHorizontal={2} paddingVertical={1} data-theme-level="1">
      {hasMore && (
        <Button
          variant="tertiary"
          size="medium"
          label={i18n('card.list.showMore')}
          loading={isMoreLoading}
          onClick={showMore}
          disabled={isDragging}
        />
      )}
    </View>
  );
}
